import React from 'react';
import './PageHead.css';
import ButtonPrimary from '../buttons/ButtonPrimary';
import { FaChevronDown } from 'react-icons/fa';
import SectionWrap from '../SectionWrap/SectionWrap';

function PageHead(props) {
  return (
    <div className='headContainer'>
      <SectionWrap className='containerNew'>
      <div className='premium-page-head'>
      <div className='page-head-content'>
        
        {/* العنوان الرئيسي الكبير مع إمكانية تمرير تأثير تلوين إن أردت */}
        <h1 className='head-title'>{props.title}</h1>
        
        {/* النصوص التوضيحية الموزعة بهندسة مريحة للعين */}
        <div className='head-description-box'>
          {props.summary && <p className='head-summary'>{props.summary}</p>}
          {props.disc && <span className='head-disc'>{props.disc}</span>}
        </div>
        
        
        
      </div>

      {/* مؤشر النزول السلس متناسق هندسياً في المنتصف السفلي */}
      <div className="scroll-indicator-wrap">
        <FaChevronDown className="indicator-arrow arrow-first" />
        <FaChevronDown className="indicator-arrow arrow-second" />
      </div>
    </div>
    </SectionWrap>
    </div>
  );
}

export default PageHead;